import { render, staticRenderFns } from "./weekview.vue?vue&type=template&id=884ab148&scoped=true&"
import script from "./weekview.vue?vue&type=script&lang=js&"
export * from "./weekview.vue?vue&type=script&lang=js&"
import style0 from "./weekview.vue?vue&type=style&index=0&id=884ab148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884ab148",
  null
  
)

export default component.exports